import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/api";
import LazyAvatar from "@/components/LazyAvatar";
import { MagnifyingGlass } from "@phosphor-icons/react";

export default function Speakers() {
  const [speakers, setSpeakers] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    const t = setTimeout(() => {
      api.get(`/speakers${q ? `?q=${encodeURIComponent(q)}` : ""}`).then((r) => setSpeakers(r.data));
    }, 200);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div data-testid="speakers-page">
      <div className="mb-4">
        <div className="font-mono-time text-xs uppercase text-[#7A828C] tracking-widest mb-1">Directory</div>
        <h1 className="font-display text-3xl sm:text-4xl tracking-tight">Speakers</h1>
      </div>

      <div className="relative mb-4">
        <MagnifyingGlass size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#7A828C]" />
        <input
          value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Search by name or affiliation…"
          className="w-full h-12 pl-10 pr-4 bg-[#FFFFFF] border border-[#E5E9F0] rounded-sm focus:border-[#000000] outline-none"
          data-testid="speakers-search-input"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {speakers.map((sp) => (
          <Link key={sp.id} to={`/speakers/${sp.id}`} data-testid={`speaker-card-${sp.id}`}
            className="flex items-center gap-3 p-4 bg-[#FFFFFF] border border-[#E5E9F0] rounded-sm hover:border-[#000000] transition-colors">
            <LazyAvatar
              endpoint={`/speakers/${sp.id}/photo`}
              hasPhoto={sp.has_photo}
              name={sp.name}
              className="w-14 h-14 rounded-sm flex-shrink-0"
              round={false}
            />
            <div className="min-w-0">
              <div className="font-display text-base truncate">{sp.name}</div>
              <div className="text-xs text-[#7A828C] truncate">{sp.affiliation}</div>
            </div>
          </Link>
        ))}
        {speakers.length === 0 && <div className="text-center py-10 text-[#7A828C] col-span-full">No speakers found.</div>}
      </div>
    </div>
  );
}
